export const ANIMAL_TYPES: Array<string> = [
  'alpaca',
  'bartgame',
  'chinchilla',
  'degu',
  'lizard',
  'fish',
  'ferret',
  'hamster',
  'hare',
  'chicken',
  'dog',
  'hedgehog',
  'rabbit',
  'cat',
  'llama',
  'mouse',
  'guineaPig',
  'hourse',
  'pony',
  'rat',
  'turtle',
  'snake',
  'pig',
  'bird',
  'bovine'
]
